import { useState } from 'react';

export const getUser = () => {
  const userString = sessionStorage.getItem('user');
  return JSON.parse(userString);
};

export const getScopes = () => {  
  const scopesString = sessionStorage.getItem('scopes');  
  return JSON.parse(scopesString);  
};

export default function useUser() {
  const [user, setUser] = useState(getUser());

  const saveUser = (user, scopes) => {
    if (user === null) {  
      sessionStorage.removeItem('user');  
      sessionStorage.removeItem('scopes');  
    } else {  
      sessionStorage.setItem('user', JSON.stringify(user));  
      sessionStorage.setItem('scopes', JSON.stringify(scopes));  
    }  
    setUser(user); 
  };

  return {
    user,
    scopes: getScopes(),
    setUser: saveUser
  };
};